import PrivacyPolicyDialog from '@/shared/components/PrivacyPolicyDialog';
import { ROUTES } from '@/config/routeConfig';
import orbiusIcon from '@/assets/orbius_icon.png';
import { useUserRoles } from '@/shared/hooks/userRoles';

const Footer = () => {
  const currentYear = new Date().getUTCFullYear();
  const { isCustomerUser, isPlatformUser } = useUserRoles();

  return (
    <footer className={`glass-panel border-t border-border bottom-0 left-0 right-0 z-20 h-24`}>
      <div className="w-full h-full flex items-center justify-between px-4 py-4">
        {/* Bottom Section */}
        <div className="flex flex-col gap-4">
          {!isCustomerUser && (
            <div className="flex flex-row gap-4">
              <p className="p-0 h-auto text-sm hover:underline">
                <PrivacyPolicyDialog />
              </p>
              <p className="p-0 h-auto text-sm hover:underline">
                <a href={ROUTES.SLA}>Service Level Agreement</a>
              </p>
              {isPlatformUser &&
                <p className="p-0 h-auto text-sm hover:underline">
                  <a href={ROUTES.USER_GUIDE}>User Guide</a>
                </p>
              }
              <p className="p-0 h-auto text-sm hover:underline">
                <a href={ROUTES.HELP_CENTER} target="_blank">Help Center</a>
              </p>
            </div>
          )}
          <div className="flex flex-row gap-2 items-center">
            <img src={orbiusIcon} alt="orbius_icon" className="h-6 w-auto" />
            <p className="text-sm">
              Orbius © {currentYear}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 